"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExclusionsZonesTable = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const formik_1 = require("formik");
const fa_1 = require("react-icons/fa");
const Button_1 = __importDefault(require("../../elements/Button"));
const ReactTable_1 = __importDefault(require("../../elements/ReactTable/ReactTable"));
const FormikInput_1 = __importDefault(require("../../elements/formik/FormikInput"));
const inputStyle = {
    input: {
        width: '100%',
        fontSize: '1.1em',
        textAlign: 'left',
    },
};
function ExclusionsZonesTable() {
    const { values, setFieldValue } = (0, formik_1.useFormikContext)();
    if (!values?.exclusionsZones || !Array.isArray(values.exclusionsZones)) {
        return null;
    }
    function handleDelete(index) {
        void setFieldValue('exclusionsZones', values.exclusionsZones.filter((_, i) => i !== index));
    }
    const exclusionsZonesColumns = [
        {
            Header: '#',
            style: { width: '50px' },
            accessor: (_, index) => index + 1,
        },
        {
            Header: 'from',
            Cell: ({ row }) => ((0, jsx_runtime_1.jsx)(FormikInput_1.default, { name: `exclusionsZones.${row.index}.from`, type: "number", style: inputStyle })),
        },
        {
            Header: 'To',
            Cell: ({ row }) => ((0, jsx_runtime_1.jsx)(FormikInput_1.default, { name: `exclusionsZones.${row.index}.to`, type: "number", style: inputStyle })),
        },
        {
            Header: '',
            style: { width: '70px' },
            id: 'actions',
            Cell: ({ row }) => {
                return ((0, jsx_runtime_1.jsx)(Button_1.default.Danger, { fill: "outline", onClick: () => handleDelete(row.index), children: (0, jsx_runtime_1.jsx)(fa_1.FaTimes, {}) }));
            },
        },
    ];
    return ((0, jsx_runtime_1.jsx)(ReactTable_1.default, { columns: exclusionsZonesColumns, data: values.exclusionsZones, emptyDataRowText: "No Zones" }));
}
exports.ExclusionsZonesTable = ExclusionsZonesTable;
